import TilesModel from "../../models/standard/TileModel";

/**
 * Helper: Instantiate tiles from JSON.
 */
export function instantiateTiles(tilesData: any): TilesModel {
  const result = new TilesModel(tilesData.length, tilesData.width, tilesData.rotation, tilesData.jointWidth, tilesData.jointColor);
  if(tilesData.uuid) {
    result.setUUID(tilesData.uuid);
  }
  return result;
}
